import React from "react";
import styled from "styled-components";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";

const AvailableButton = styled.div`
  display: flex;
  padding: ${calc(6)} ${calc(8)};
  justify-content: center;
  align-items: center;
  border-radius: ${calc(5)};
  background: #ff514e;
  color: #fff;
  font-family: "Spoqa Han Sans Neo";
  font-size: ${calc(12)};
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  cursor: pointer;
  transition-property: all;
  transition: 0.1s ease-in-out;

  &:active {
    scale: 0.95;
    opacity: 0.8;
  }
`;

const DisabledButton = styled.div`
  display: flex;
  padding: ${calc(6)} ${calc(8)};
  justify-content: center;
  align-items: center;
  border-radius: ${calc(5)};
  background: #e0e0e0;
  color: #fff;
  font-family: "Spoqa Han Sans Neo";
  font-size: ${calc(12)};
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

export function MissionsBottomSheetContent(props) {
  return (
    <>
      {props.missions.map((mission, index) => (
        <div
          key={`mission-${index}-${mission.id}`}
          id="missions-content"
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <img
            style={{
              width: calc(40),
              height: calc(40),
            }}
            src={mission.image_url}
          />

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginLeft: calc(12),
              flex: "1 0 0",
            }}
          >
            <div
              style={{
                color: "#212121",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(16),
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "150%",
              }}
            >
              {mission.name}
            </div>

            {mission.opportunity_type === "special" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  style={{
                    width: calc(16),
                    height: calc(16),
                  }}
                  src="/games/fruits/assets/ic-fruits-ticket-special.png"
                />
                <div
                  style={{
                    color: "#D365F9",
                    textAlign: "center",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(14),
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "150%",
                    marginLeft: calc(2),
                  }}
                >
                  스페셜 도전권 {mission.gain_opportunity}개
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  style={{
                    width: calc(16),
                    height: calc(16),
                  }}
                  src="/games/fruits/assets/ic-fruits-ticket.png"
                />
                <div
                  style={{
                    color: "#FF8A00",
                    textAlign: "center",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(14),
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "150%",
                    marginLeft: calc(2),
                  }}
                >
                  도전권 {mission.gain_opportunity}개
                </div>
              </div>
            )}
          </div>

          {mission.type === "1" ? (
            <AvailableButton
              onClick={() => {
                props.mission(mission);
              }}
            >
              공유하기
            </AvailableButton>
          ) : null}

          {mission.type === "2" ? (
            <AvailableButton
              onClick={() => {
                props.mission(mission);
              }}
            >
              초대하기
            </AvailableButton>
          ) : null}

          {mission.type === "8" || mission.type === "9" ? (
            props.drawOpportunityCount >= 3 ? (
              <DisabledButton className="mission-cta-button">
                도전권 가득참
              </DisabledButton>
            ) : mission.status === 0 ? (
              <DisabledButton>완료</DisabledButton>
            ) : (
              <AvailableButton
                onClick={() => {
                  props.mission(mission);
                }}
              >
                받기
              </AvailableButton>
            )
          ) : null}
        </div>
      ))}
    </>
  );
}
